/* istanbul ignore file */
import { useEffect } from 'react';
import { Routes } from 'react-router-dom';
import { GlobalProtectedRoute } from 'framework/authorization';
import { Route } from 'framework/routing';
import { useDispatch } from 'react-redux';
import { clearTimer } from 'framework/ui/DataTimer';

import { Page404 } from 'framework/statusPages';
import useAuthenticationService from 'infrastructure/security/authentication/authenticationService';
import ListPage from 'domain/people/employee/finance/List';
import ViewPage from 'domain/people/employee/finance/Show';
import { Create, Update } from 'domain/people/employee/finance/createupdate';

import FinanceContext from 'domain/people/employee/finance/FinanceContext';
import { READ_EMPLOYEE_COMPENSATION_PACKAGES } from 'domain/shared/employee';
import {
  CREATE_COMPENSATION_PACKAGE,
  useFinanceRoute,
  useFinanceUrl,
} from 'domain/people/employee/finance/financeRouting';
import {
  FINANCE_READ_EMPLOYEE_COMPENSATION_PACKAGE,
  FINANCE_UPDATE_EMPLOYEE_COMPENSATION_PACKAGE,
} from 'domain/people/employee/finance/shared/financeService';

const FinanceRouter = () => {
  const { isAuthenticated } = useAuthenticationService();
  const { listRoute, createRoute: createFinanceRoute, updateRoute, singleEntityRoute } = useFinanceRoute();
  const { getListUrl } = useFinanceUrl();
  const listUrl = getListUrl();
  const dispatch = useDispatch();

  useEffect(() => {
    return () => {
      dispatch(clearTimer(listUrl));
    };
    // Suppressed warnings because we only need to call useEffect callback ones after the first mount.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Routes>
      <Route
        path={listRoute}
        element={
          <GlobalProtectedRoute globalPermissionToCheck={READ_EMPLOYEE_COMPENSATION_PACKAGES}>
            <ListPage />
          </GlobalProtectedRoute>
        }
      />

      <Route
        path={createFinanceRoute}
        element={
          <GlobalProtectedRoute path={createFinanceRoute} globalPermissionToCheck={CREATE_COMPENSATION_PACKAGE}>
            <Create />
          </GlobalProtectedRoute>
        }
      />

      <Route
        path={updateRoute}
        element={
          <FinanceContext permissionToCheck={FINANCE_UPDATE_EMPLOYEE_COMPENSATION_PACKAGE}>
            <Update />
          </FinanceContext>
        }
      />

      <Route
        path={singleEntityRoute}
        element={
          <FinanceContext permissionToCheck={FINANCE_READ_EMPLOYEE_COMPENSATION_PACKAGE}>
            <ViewPage />
          </FinanceContext>
        }
      />

      <Route path="*" element={<Page404 isAuthenticated={isAuthenticated} />} />
    </Routes>
  );
};

export default FinanceRouter;
